/* @example 2020-06-30 */
export type APIDate = `${number}${number}${number}${number}-${number}${number}-${number}${number}`;
